import { render, staticRenderFns } from "./StudyResultSummaryTable.vue?vue&type=template&id=23da6955&scoped=true&lang=pug"
import script from "./StudyResultSummaryTable.vue?vue&type=script&lang=ts"
export * from "./StudyResultSummaryTable.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultSummaryTable.vue?vue&type=style&index=0&id=23da6955&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da6955",
  null
  
)

export default component.exports